/* globals defaultProductSlug, currentProductTypeId, siteurl */

import Vue from 'vue';
import axios from 'axios';
import * as common from './common';


const axiosInstance = axios.create({
  baseURL: siteurl,
  timeout: 10000,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
});

const initializeProductDetails = function() {
  const productDetailsTable = new Vue({
    el: '#product-details',
    data: {
      productId: '',
      formats: [],
      productTypes: [],
      details: [],
      selectedProductType: {},
      withWoodenFrame: 0,
    },
    watch: {},
    methods: {
      outputFormat(format) {
        const underscoreFormat = format.replace(':', '_');
        return `format-${underscoreFormat}`;
      },
      sizeRow(size) {
        return size.show_size;
      },
      /*
      hasFrame() {
        console.log(this.selectedProductType.has_frame);
        return this.selectedProductType.has_frame;
      },
      */
      setInitialProductType() {
        const initialProductType = defaultProductSlug || 'poster'; // 5; // this.$refs.bla.value;
        this.selectedProductType = this.productTypes.find(item => item.slug === initialProductType);
      },
      changeProductById(productTypeId) {
        const productTypeIdInt = parseInt(productTypeId, 10);
        this.selectedProductType = this.productTypes.find(item => item.id === productTypeIdInt);
        this.changeProduct();
      },
      isSelected(productTypeId) {
        return productTypeId === this.selectedProductType.id;
      },
      productPrice(size) {
        return common.formatPrice(size.price);
      },
      changeProduct() {
        this.getProductsData();
      },
      getProductTypesList() {
        axiosInstance.get('ajax/getProductTypesList')
          .then((response) => {
            this.productTypes = response.data;
            this.setInitialProductType();
            this.getProductsData();
          });
      },
      getProductsData() {
        axiosInstance.get(
          'ajax/productDetailsPhotoPage',
          {
            params: {
              product_type_id: this.selectedProductType.id,
              productSlug: this.selectedProductType.slug,
              frame: this.withWoodenFrame,
            },
          },
        )
          .then((response) => {
            this.details = response.data;

            // check if the chosen product type id should show the "express delivery available" div
            let expressDeliveryProductTypeIds = $(".express-delivery-block").data('available-product-types').split(',');
            if( expressDeliveryProductTypeIds.includes(""+this.selectedProductType.id) ) {
              $(".express-delivery-block").show();
            }
            else {
              $(".express-delivery-block").hide();
            }
          })
          .catch((error) => {
          });
      },
    },
    computed: {
      hasFrame() {
        return this.selectedProductType.has_frame;
      },
    },
    mounted() {
      this.getProductTypesList();
  
      $('.photo-page-product-option-wrap').on('change', '.select-product-type', () => {
        const productId = $('.select-product-type:checked').val();
        this.changeProductById(productId);
      });
    },
  });
  Vue.config.devtools = false;
  
}

export {
  initializeProductDetails,
};